import { Box, Card, Text } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

const PageContentCard = ({ children }: PropsWithChildren) => {
    return (
        <Box 
            flex='1' 
            alignSelf='self-start' 
            padding={2.5} 
            height='calc(100vh - var(--headerHeight))' 
            overflowY='auto'
        >
            <Card.Root borderRadius={5} variant='elevated' minH='100%'>
                <Card.Body>
                    {children}
                </Card.Body>
            </Card.Root>
        </Box>
    )
}

export default PageContentCard;